import { render, staticRenderFns } from "./admin-multidemo.vue?vue&type=template&id=e2737926&scoped=true&"
import script from "./admin-multidemo.vue?vue&type=script&lang=js&"
export * from "./admin-multidemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2737926",
  null
  
)

export default component.exports